export const environment = {
  production: true,
  apiUrl: "https://hygge-uat.ddns.net/p2p-api/v1/",
  websocket_url:
    "wss://hygge-uat.ddns.net/p2p-notifications/v1/notifications/",
  project_prefix: "p2p_uat",
};

